// component
import Iconify from "../../components/Iconify";

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const superAdminSidebarConfig = [
  {
    title: "داشبورد",
    path: "/dashboard/app",
    icon: getIcon("eva:pie-chart-2-fill"),
    key: "DASHBOARD",
  },
  {
    title: "ارزشگذاری طرح ها",
    path: "/dashboard/startup-valuation/list",
    icon: getIcon("fa6-solid:ranking-star"),
    key: "STARTUP_VALUATION",
  },
  {
    title: "درخواست‌های سرمایه‌گذاری",
    path: "/dashboard/investing-requests/start-up/list",
    icon: getIcon("fluent:money-hand-24-filled"),
    key: "INVESTING_REQUESTS",
  },
  {
    title: "مدیریت طرح ها",
    path: "/dashboard/manage-startup/list",
    icon: getIcon("el:idea-alt"),
    key: "MANAGE_STARTUP",
  },
  {
    title: "مدیریت سرمایه‌گذاران",
    path: "/dashboard/manage-investor/list",
    icon: getIcon("ant-design:pie-chart-filled"),
    key: "INCREASE_CREDIT",
  },
  {
    title: "لیست شکایات",
    path: "/dashboard/manage-complaint/list",
    icon: getIcon("ant-design:message-filled"),
    key: "INCREASE_CREDIT",
  },
  {
    title: "مدیریت کاربران",
    path: "/dashboard/users/list",
    icon: getIcon("fa-solid:users"),
    key: "USERS",
  },
  {
    title: "مدیریت کاربران ادمین",
    path: "/dashboard/admins/list",
    icon: getIcon("fa-solid:users"),
    key: "ADMINS",
  },
  {
    title: "تیکت پشتیبانی",
    path: "/dashboard/ticket/list",
    icon: getIcon("ant-design:message-filled"),
    key: "TICKET",
  },
  // {
  //   title: 'دسته بندی',
  //   path: '/dashboard/categories/list',
  //   icon: getIcon('bxs:category'),
  //   key: 'CATEGORIES',
  // },
  {
    title: "تراکنش ها",
    path: "/dashboard/invoices/list",
    icon: getIcon("fa6-solid:file-invoice-dollar"),
    key: "INVOICES",
  },
  {
    title: " اخبار",
    path: "/dashboard/news/list",
    icon: getIcon("fluent:news-20-filled"),
    key: "NEWS",
  },
  // {
  //   title: "فیش های آپلود شده",
  //   path: "/dashboard/receipts/list",
  //   icon: getIcon("fluent:receipt-20-filled"),
  //   key: "RECEIPTS",
  // },
  // {
  //   title: 'تنظیمات',
  //   path: '/dashboard/setting',
  //   icon: getIcon('ant-design:setting-filled'),
  //   key: 'SETTING',
  // },
];

export default superAdminSidebarConfig;
